const RADIUS_OPTIONS = [
   {
      value: 5,
      label: '5 miles',
      id: 5,
      name: 5,
   },
   {
      value: 10,
      label: '10 miles',
      id: 10,
      name: 10,
   },
   {
      value: 25,
      label: '25 miles',
      id: 25,
      name: 25,
   },
   {
      value: 50,
      label: '50 miles',
      id: 50,
      name: 50,
   },
];

export default RADIUS_OPTIONS;
